import React from "react";
import Slider from "react-slick";
import { v4 as uuid } from "uuid";
import { ReactComponent as Btn } from "../../../../assets/img/landings/a2b/next_btn.svg";
import "./slick.min.css";
import "./index.css";

function Arrow(props) {
  const { className, style, onClick, children } = props;
  return (
    <button className={className} style={{ ...style }} onClick={onClick}>
      {children}
    </button>
  );
}

const Carousel = ({ slides }) => {
  const settings = {
    nextArrow: (
      <Arrow>
        <Btn />
      </Arrow>
    ),
    prevArrow: (
      <Arrow>
        <Btn />
      </Arrow>
    ),
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1152,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 840,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div>
      <Slider {...settings}>
        {slides.map(({ title, text }, index) => {
          return (
            <div
              key={uuid()}
              className="a2b-microservices-slide"
              data-index={index < 9 ? `0${index + 1}` : index + 1}
            >
              <h3 className="a2b-microservices-slide__title">{title}</h3>
              <p className="a2b-microservices-slide__text">{text}</p>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default Carousel;
